<template>
  <div
    @click="$emit('changeTask', task)"
    class="calendar-main-time-block-task-wrapper mb-1"
    :class="newClass"
  >
    <span class="mr-1">{{ task.id }}</span><span class="task-wrapper-text">{{ task.title }}</span>
    <span class="calendar-task-small-icon" title="Задача завершена" v-if="task.reference_status_id == 403">✓</span>                
    <span class="calendar-task-small-icon" title="Задача на проверке" v-if="task.reference_status_id == 402">👁</span>
    <span class="calendar-task-small-icon" title="Задача в работе" v-if="task.reference_status_id == 401">✐</span>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {},
    },
    newClass: {
      type: String,
      default: '',
    }
  },
}
</script>